/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Add_FtpInputs */

const en_ui_thresholds_add_ftp = /** @type {(inputs: Ui_Thresholds_Add_FtpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add FTP`)
};

const de_ui_thresholds_add_ftp = /** @type {(inputs: Ui_Thresholds_Add_FtpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FTP eintragen`)
};

/**
* | output |
* | --- |
* | "Add FTP" |
*
* @param {Ui_Thresholds_Add_FtpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_add_ftp = /** @type {((inputs?: Ui_Thresholds_Add_FtpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Add_FtpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_add_ftp(inputs)
	return de_ui_thresholds_add_ftp(inputs)
});